import { ApiUrl } from "../config/apiConfig";
import { postData } from "../services/Axios/Axios";

const sendAccountStatusChangeMail = (
  email: string,
  username: string,
  status: string,
  password: string = "qwerty",
  captchaToken: string = ""
) => {
  let mailTemplate;

  if (status === "CONFIRMED") {
      mailTemplate = {
        subject: "🎉 Your Account Has Been Approved By Awahe Academy!",
        html: `
        <div style="font-family: Arial, sans-serif; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #e0e0e0; border-radius: 10px; background-color: #f9fdf9;">
          
          <h2 style="color: #007070;">✅ Hi ${username}, your account has been approved by Awahe Academy!</h2>
          
          <p style="font-size: 16px; color: #333;">
            We’re excited to welcome you! Your account has been successfully approved.
          </p>
          <p style="font-size: 16px; color: #333;">
            You can now log in and start exploring all the features of our platform.
          </p>
        
          <!-- Credentials Box -->
          <div style="margin: 30px 0; padding: 20px; background-color: #e6f7f7; border-left: 5px solid #007070; border-radius: 8px;">
            
            <p style="margin: 0 0 12px 0; font-size: 16px; color: #007070;">
              <strong>Your login credentials:</strong>
            </p>
        
            <p style="margin: 8px 0; font-size: 15px; color: #333;">
              <strong>Email:</strong> ${email}
            </p>
        
            <!-- Password Box -->
            <div style="margin-top: 15px;">
              <p style="margin: 0 0 6px 0; font-size: 14px; color: #555;">
                <strong>Password:</strong>
              </p>
        
              <div style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: #ffffff;
                border: 1px dashed #007070;
                border-radius: 6px;
                padding: 10px 12px;
                font-family: monospace;
                font-size: 15px;
                color: #000;
                user-select: all;
              ">
                <span>${password}</span>
        
               
              </div>
        
             
            </div>
        
          </div>
        
          <!-- Login Button -->
          <div style="text-align: center; margin: 30px 0;">
            <a href="https://app.awahe.com/" 
               style="display: inline-block; padding: 12px 25px; background-color: #007070; color: white; text-decoration: none; border-radius: 5px; font-size: 16px;">
               Log In
            </a>
          </div>
        
          <p style="font-size: 14px; color: #888;">
            Need help? Reach out to our support team anytime.
          </p>
        
        </div>
        `
      };
  } else if (status === "DENIED") {
      mailTemplate = {
          subject: "⚠️ Your Account Request Has Been Rejected",
          html: `<div style='font-family: Arial, sans-serif; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #ffe0e0; border-radius: 10px; background-color: #fff8f8;'>\n  <h2 style='color: #f44336;'>⛔ Hello ${username}, we’re sorry to inform you</h2>\n  <p style='font-size: 16px; color: #444;'>Your account registration request has been <strong>rejected</strong> after review by our admin team.</p>\n  <p style='font-size: 16px; color: #444;'>This may be due to missing information or not meeting our eligibility criteria.</p>\n  <p style='font-size: 16px; color: #444;'>You are welcome to re-apply or contact support for clarification.</p>\n  <div style='margin-top: 30px;'>\n    <a href='mailto:info@awahe.com' style='display: inline-block; padding: 10px 20px; background-color: #f44336; color: white; text-decoration: none; border-radius: 5px;'>Contact Support</a>\n  </div>\n</div>`,
      };
  } else {
      mailTemplate = {
          subject: "⏳ Your Account is Under Review",
          html: `<div style='font-family: Arial, sans-serif; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #ddd; border-radius: 10px; background-color: #fcfcfc;'>\n  <h2 style='color: #2196F3;'>🔎 Hello ${username}, your account is currently pending review</h2>\n  <p style='font-size: 16px; color: #333;'>Thank you for submitting your registration request.</p>\n  <p style='font-size: 16px; color: #333;'>Our admin team is currently reviewing your details. We will notify you as soon as your account is either <strong>approved</strong> or <strong>rejected</strong>.</p>\n  <p style='font-size: 16px; color: #333;'>We appreciate your patience and will get back to you shortly.</p>\n  <div style='margin-top: 30px;'>\n    <p style='font-size: 14px; color: #888;'>For urgent queries, feel free to contact our support team.</p>\n  </div>\n</div>`,
      };
  }

  const payload = {
      emailType: "custom",
      recipient: email,
      data: mailTemplate,
      "cf-turnstile-response": captchaToken,
  };

  return postData(ApiUrl.sendMail, payload);
};


const sendLoginCredentialsMail = (email: string, password: string, captchaToken: string = "") => {
  const payload = {
      emailType: "custom",
      recipient: email,
      "cf-turnstile-response": captchaToken,
      data: {
          subject: "Your Login Email & Password",
          html: `
          <div style="font-family: Arial, sans-serif; padding: 25px; max-width: 600px; margin: auto; border: 1px solid #cce3e3; border-radius: 10px; background-color: #f5fafa;">
            
            <h2 style="color: #007070; margin-top: 0;">
              🔐 Your Login Credentials
            </h2>
          
            <p style="font-size: 16px; color: #333; line-height: 1.6;">
              You requested your login credentials. Please find your details below:
            </p>
          
            <!-- Credentials Box -->
            <div style="margin: 25px 0; padding: 20px; background-color: #e6f7f7; border-left: 5px solid #007070; border-radius: 8px;">
              
              <p style="margin: 0 0 10px 0; font-size: 15px; color: #333;">
                <strong>📧 Email:</strong> ${email}
              </p>
          
              <!-- Password UI -->
              <div style="margin-top: 15px;">
                <p style="margin: 0 0 6px 0; font-size: 14px; color: #555;">
                  <strong>🔑 Password:</strong>
                </p>
          
                <div style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  background: #ffffff;
                  border: 1px dashed #007070;
                  border-radius: 6px;
                  padding: 10px 12px;
                  font-family: monospace;
                  font-size: 15px;
                  color: #000;
                  user-select: all;
                ">
                  <span>${password}</span>
          
                 
                </div>
          
               
              </div>
          
            </div>
          
            <p style="font-size: 15px; color: #444; line-height: 1.6;">
              For security reasons, we strongly recommend changing your password after logging in.
            </p>
          
            <!-- Footer -->
            <div style="margin-top: 30px; padding: 15px; background-color: #ffffff; border-top: 1px dashed #007070;">
              <p style="margin: 0; font-size: 14px; color: #555;">
                ❗ If you did not request this email, please contact our support team immediately.
              </p>
              <p style="margin: 10px 0 0 0; font-size: 14px; color: #555;">
                — The Awahe Team
              </p>
            </div>
          
          </div>
          `
      },
  };

  return postData(ApiUrl.sendMail, payload);
};

export { sendAccountStatusChangeMail ,sendLoginCredentialsMail};
